import api from "@/services/api";
import axios from "axios";

export default {
  getToken() {
    return axios.get(process.env.VUE_APP_ARCGIS_TOKEN_URL, {
      params: {
        client_id: process.env.VUE_APP_ARCGIS_ID,
        grant_type: "client_credentials",
        client_secret: process.env.VUE_APP_ARCGIS_SECRET,
        f: "pjson"
      }
    });
  },
  createGeocode(payload) {
    return this.getToken().then(response => {
      const accessToken = response.data.access_token;
      const address = {
        records: [
          {
            attributes: {
              OBJECTID: 1,
              Address: payload.address,
              City: payload.city,
              Region: payload.state,
              Postal: payload.postal_code
            }
          }
        ]
      };

      const formattedAddress = encodeURI(JSON.stringify(address));
      const url = `${process.env.VUE_APP_ARCGIS_GEOCODE_URL}addresses=${formattedAddress}`;

      return axios
        .get(url, {
          timeout: 5000,
          params: {
            forStorage: true,
            token: accessToken,
            f: "pjson"
          }
        })
        .then(response => {
          return response.data.locations[0];
        })
        .catch(() => {
          return this.alternativeGeocode(payload).then(response => {
            return response;
          });
        });
    });
  },
  postStakeholder(payload) {
    return api.post(`stakeholders/`, payload).then(response => {
      return response.data;
    });
  },
  lookUpStakeholder(payload) {
    return api
      .post(`stakeholders/look_up_stakeholder/`, payload)
      .then(response => {
        return response.data;
      });
  }
};
